<div
  class="rounded-input box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    'bg-inherit': !isDarkMode(),
  }"
  [ngStyle]="{
    backgroundColor: inputBackground(),
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="rounded-input relative w-full bg-inherit! text-base">
    <div class="relative bg-inherit">
      <input
        [tabindex]="ngControl.control!.disabled ? '-1' : '0'"
        class="border-input-ring border-input rounded-input peer p-input box-border flex w-full cursor-pointer flex-row items-center bg-transparent placeholder-transparent focus:ring-0 focus:outline-none"
        [ngClass]="{
          'border-input-error focus:border-input-focus': hasError,
          'border-input-ring focus:border-input-focus': !hasError,
          'pointer-events-none': ngControl.disabled,
          'text-standard-text-dark': corporateDesignService.isDarkModeActive(),
          'text-standard-text': !corporateDesignService.isDarkModeActive(),
        }"
        [formControl]="innerControl"
        [ngStyle]="{
          borderRadius: borderRounding(),
          borderColor: borderAndLabelColor(),
        }"
        [id]="id()"
        (focus)="isFocused.set(true)"
        (blur)="setDateFromInnerControl(); isFocused.set(false)"
        (keydown.space)="$event.preventDefault()"
        (click)="showCalendar.set(!showCalendar())"
        [attr.data-testid]="id() | appendTestId: 'input'"
        [type]="showTimePicker() ? 'datetime-local' : 'date'" />   
      <label
        [attr.data-testid]="id() | appendTestId: 'label'"
        class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 z-2 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
        [ngClass]="{
          'text-input-error': hasError,
          'text-input-focus': isFocused(),
          'text-standard-text-dark': !hasError && corporateDesignService.isDarkModeActive(),
          'text-standard-text': !corporateDesignService.isDarkModeActive(),
        }"
        [ngStyle]="{color: borderAndLabelColor()}"
        [for]="id()">
        {{ formattedLabel() }}
      </label>
      @if (!ngControl.control!.disabled) {
        <div class="text-input-label absolute top-3 right-4 flex items-center gap-3 text-lg">
          @if (ngControl.control?.value) {
            <button
              [tabindex]="ngControl.control!.disabled ? '-1' : '0'"
              type="button"
              aria-label="Clear"
              [attr.data-testid]="id() | appendTestId: 'clear'"
              class="hover:bg-standard-hover-main/30 hover:border-standard-text-secondary focus:bg-standard-hover-main/30 focus:border-standard-text-secondary flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-1 border-transparent focus:outline-none"
              (keyup.enter)="reset()"
              (click)="reset()">
              <span class="material-symbols-rounded">close</span>
            </button>
          }
          <button
            type="button"
            aria-label="Datum auswählen"
            [id]="id() | appendTestId: 'arrow-down'"
            [attr.data-testid]="id() | appendTestId: 'arrow-down'"
            class="hover:bg-standard-hover-main/30 hover:border-standard-text-secondary focus:bg-standard-hover-main/30 focus:border-standard-text-secondary flex h-7 w-7 cursor-pointer items-center justify-center rounded-sm border-1 border-transparent focus:outline-none"
            (click)="showCalendar.set(!showCalendar())">
            <span class="material-symbols-rounded">calendar_month</span>
          </button>
        </div>
      }
    </div>
    @if (showCalendar()) {
      <div
        awPopupPosition
        [anchor]="id()"
        [limitMaxWidth]="false"
        [isVisible]="true"
        class="border-input-ring fixed top-0 bottom-0 left-0 z-30 flex w-full justify-center rounded-lg border-1 md:fixed md:top-auto md:bottom-auto md:left-auto md:size-fit md:w-auto"
        [id]="id() | appendTestId: 'calendar'"
        [attr.data-testid]="id() | appendTestId: 'calendar'"
        [ngClass]="{
          'bg-primary-on': !isDarkMode(),
        }"
        [ngStyle]="{
          color: textColor(),
          borderRadius: borderRounding(),
          background: isDarkMode()
            ? corporateDesign().colorAdmixtures.dark_surface_01
            : '',
        }">
        <aw-calendar
          #calendar
          [label]="label()"
          [borderRounding]="borderRounding()"
          [showTimePicker]="showTimePicker()"^  
          [id]="id() | appendTestId: 'calendar'"
          [parentId]="id()"
          [date]="ngControl!.value"
          [min]="min()"
          [max]="max()"
          (onCloseCalendar)="closeCalendar()"
          (onDateConfirm)="onDateChange($event)"
          [restrictedDateList]="restrictedDateList()"></aw-calendar>
      </div>
    }
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
